<template>
	<div class="d-flex">
		<a-button icon="plus" @click="show"> Add Account </a-button>
		<a-modal
			title="Create Account"
			:visible="visible"
			:confirm-loading="loading"
			@ok="
				() => {
					form.validateFields((err, values) => {
						if (!err) {
							handleForm(values)
						}
					})
				}
			"
			@cancel="hide"
		>
			<a-form
				id="create-account"
				:form="form"
				:label-col="{ span: 7 }"
				:wrapper-col="{ span: 17 }"
				@submit="handleForm"
				class="p-2"
			>
				<a-row :gutter="4">
					<a-col>
						<a-form-item label="Nombre">
							<a-input
								v-decorator="[
									'name',
									{
										rules: [
											{
												required: true,
												message: 'Campo requerido',
											},
										],
									},
								]"
								placeholder=""
							/>
						</a-form-item>
					</a-col>
					<a-col :span="24">
						<a-form-item label="Tipo de cuenta">
							<a-select
								v-decorator="[
									'type',
									{
										rules: [
											{
												required: true,
												message: 'Campo requerido',
											},
										],
									},
								]"
								placeholder="Please choose one type"
							>
								<a-select-option
									v-for="(account, key) in getAccountTypeList"
									v-bind:value="account.id"
									v-bind:key="key"
									>{{ account.name }}</a-select-option
								>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>
			</a-form>
		</a-modal>
	</div>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'AccountCreate',
	data: function() {
		return {
			visible: false,
			form: this.$form.createForm(this),
			loading: false,
		}
	},
	methods: {
		show() {
			this.visible = true
		},
		hide() {
			this.visible = false
		},
		handleForm(values) {
			this.loading = true
			this.createAccount({
				name: values.name,
				typeId: values.type,
			})
				.then(() => {
					this.form.resetFields()
					this.visible = false
				})
				.finally(() => {
					this.loading = false
				})
		},
		...mapActions({
			createAccount: ACTIONS.ACCOUNT.CREATE,
		}),
	},
	computed: {
		...mapGetters(['getCurrentUser', 'getAccountTypeList']),
	},
}
</script>

<style></style>
